<template>
  <div class="w-100" id="list">
    <vue-good-table
      :columns="columns"
      :rows="orders"
      @on-row-click="openWindow"
      :search-options="{
        enabled: true,
        trigger: 'enter',
        skipDiacritics: true,        
      }"
    ></vue-good-table>
  </div>
</template>

<script>

import moment from 'moment'
import api from '@/api'
import { VueGoodTable } from 'vue-good-table'

// import the styles
import 'vue-good-table/dist/vue-good-table.css'
// import moment from 'moment'

export default {
  name: 'orders-list',

  props: ['orders', 'selectedStatus'],

  components: {
    VueGoodTable
  },

  data() {
    return {
      selectedOrder: {id: 1},
      columns: [
        {
          label: 'Client',
          html: true,
          field: row => `<img src="${row.client.logo_url}" height="35" style="border-radius: 10px;" class="mr-2" />${row.client.nickname}`,
        },
        {
          label: 'Trans#',
          field: row => `TR-${row.id}`,
        },
        {
          label: 'PO#',
          field: 'po_number',
        },        
        {
          label: 'Status',
          field: row => `${row.status.name}`,
        },
        {
          label: 'Pickup',
          field: row => `${row.origin.city}, ${row.origin.state}`,
          filterable: true,
        },
        {
          label: 'Pickup Time',
          field: 'pickup_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
          dateOutputFormat: 'Pp',
          filterable: true,
        },        
        {
          label: 'Drop Off',
          field: row => `${row.destination.city}, ${row.destination.state}`,
          filterable: true,
        },
        {
          label: 'Drop Time',
          field: 'appointment_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
          dateOutputFormat: 'Pp',
          filterable: true,
        },
        {
          label: 'Goods',
          field: row => `${row.qty_total} ${row.units}`,
          filterable: true,
        },
        {
          label: 'Driver',
          field: 'driver.name',
          filterable: true,
        },
        {
          label: 'Created',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
          dateOutputFormat: 'M/dd/yyyy HH:mm',
          filterable: true,
        },           
      ]
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.selectedOrder = { id: this.$route.params.id }
      this.$refs.detail.$refs.modal.open()
    }
  },

  watch: {
    selectedStatus() {
      this.checkedIds = []
    },

    '$route.params.id': function(id) {
      this.selectedOrder = { id: id }
      if (id) {
        this.$refs.detail.$refs.modal.open()
      } else {
        this.$refs.detail.$refs.modal.close()
      }
    }
  },

  methods: {
    openWindow(params) {
      this.$router.push(`/transport/${params.row.id}`)
    },

    labelsUrl(id) {
      return `${api.baseUrl}/transport/${id}/plcb-labels`
    },

    bolUrl(id) {
      return `${api.baseUrl}/transport/${id}/bol`
    },

    calendar(date) {
      return moment(date).format('l')
    }
  },

  computed: {
    filteredOrders() {
      return this.orders
    }
  }
}
</script>

<style>

.vgt-table td, .vgt-table th{
  font-size: 14px;
}

</style>